const getCountryById = <T extends { iso1Code?: string }[]>(
  countries: T,
  countryId?: string
) => {
  const id = countryId || '';

  return countries.find(({ iso1Code }) => {
    const iso = iso1Code || '';

    return iso.toLowerCase() === id.toLowerCase();
  });
};

export default getCountryById;
